import SuburbArticles from './suburb-articles';
export default SuburbArticles;